<template lang="pug">
component(
    :is="tagName"
    :class="{ small: small, large: large }"
    :href="href"
    class="tl-button-text"
)
    div(
        style="cursor: pointer"
        @mouseenter="hovered = true"
        @mouseleave="hovered = false"
    )
        span(
            :class="[...textClasses, hovered ? 'active' : undefined]"
            class="content"
        )
            slot
    div(
        :class="{ active: hovered }"
        class="icon"
    )
        i(
            :class="{ small: small, large: large }"
            class="mi-arrow-right"
        )
</template>

<script setup>
import { computed, ref } from 'vue'
// import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    href: String,
    large: Boolean,
    small: Boolean,
    disabled: Boolean,
    uppercase: Boolean,
    color: String,
})

// const injects = getInjects(props, inject)

const hovered = ref(false)

// const color = computed(() => props.color ?? injects.color?.value ?? 'black')
// const disabled = computed(() => props.disabled ?? injects.disabled?.value)
// const uppercase = computed(() => props.uppercase ?? injects.uppercase?.value)
const tagName = computed(() => (props.href ? 'a' : 'button'))
const textClasses = computed(() => {
    const out = []
    if (props.small) out.push('text-5')
    else if (props.large) out.push('text-3')
    else out.push('text-4')
    return out
})

</script>

<style lang="sass" scoped>
.tl-button-text
    background-color: transparent
    border: none
    padding: 0 !important
    margin: 0 !important
    display: inline-block
    position: relative
    >div
        padding: 0 5px !important
        border-radius: var(--border-radius)
    .icon
        position: absolute
        width: 16px
        right: -20px
        top: 0
        height: 100%
        padding: 0 !important
        display: flex
        align-items: center
        justify-content: flex-end
        transition: var(--transition-default)
        i
            font-size: 14px
            &.small
                font-size: 12px
            &.large
                font-size: 16px
        &.active
            transform: translateX(20px)
            opacity: 0
    .content
        position: relative

        &:after
            content: ""
            display: block
            position: absolute
            bottom: -2px
            width: 0%
            height: 1px
            background-color: var(--color-black)
            transition: var(--transition-default)
        &.active
            &:after
                width: 100%

    &.small
        .icon
            right: -12px !important
    &.large
        .icon
            right: -24px !important
</style>
